import React from 'react';
import TableFilter from './table_filter';
import styles from './table.module.scss';

export default class TableMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleAddItem = this.handleAddItem.bind(this);
    }

    handleAddItem(e) {
        e.preventDefault();
        this.props.addItemFunction();
    }

    render() {
        return (
            <div className={styles.table_action_menu}>
                {
                    this.props.itemsFilter &&
                        this.props.itemsFilter.filterProps &&
                        <TableFilter id={this.props.id} itemsFilter={this.props.itemsFilter}
                                     getFilteredItems={this.props.getFilteredItems}/>
                }
                {
                    this.props.addItemFunction &&
                        <button className={styles.add_item_button} onClick={this.handleAddItem}></button>
                }
                {
                    this.props.getReportFunction &&
                    <button className={styles.get_report_button} onClick={() => this.props.getReportFunction(this.props.itemsFilter)}></button>
                }
            </div>
        );
    }
}